export function cycleState<T>(possibilities: T[], currentState: T) {
  const { length } = possibilities;
  const index = possibilities.findIndex(
    (current: T) => current === currentState
  );
  return possibilities[(index + 1) % length];
}
